module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-login-page"
  }, [_c('div', {
    staticClass: "row login-page-container align-middle collapse"
  }, [_c('div', {
    staticClass: "columns hide-for-small-only small-12 medium-6 region-left align-self-middle"
  }, [_c('div', {
    staticClass: "col-wrapper"
  }, [_c('div', {
    staticClass: "branding full"
  }, [_c('img', {
    attrs: {
      "src": _vm.positiveLogo
    }
  })])])]), _c('div', {
    staticClass: "columns small-12 small-order-1 medium-6 region-right"
  }, [_c('div', {
    staticClass: "col-wrapper"
  }, [_c('img', {
    staticClass: "show-for-small-only",
    attrs: {
      "src": _vm.positiveLogo
    }
  }), _c('h1', {
    staticClass: "welcome-title"
  }, [_vm._v("Login to your account")]), _c('login', {
    on: {
      "login": _vm.loginHandler
    }
  }, [(_vm.error_message) ? _c('div', {
    staticClass: "login-error-message"
  }, [_vm._v(_vm._s(_vm.error_message))]) : _vm._e()])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d666790e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LoginPage.vue
// module id = 2547
// module chunks = 1